import { ApexOptions } from "apexcharts";
import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";

const CardEnvioDados: React.FC<any> = (props) => {
  const [data, setData] = useState<any>({
    series: [44, 55, 67, 83],
    options: {
      chart: {
        height: 350,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "16px",
            },
            total: {
              show: true,
              label: "Total",
              formatter: function () {
                // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                return 249;
              },
            },
          },
        },
      },
      labels: ["Apples", "Oranges", "Bananas", "Berries"],
    },
  });

  useEffect(() => {}, []);

  return (
    <div className="card" style={{ height: "433px" }}>
      <div className="card-body align-self-center">
        <h5 className="card-title fw-bold fs-22px text-center mb-5">
          Envio de dados (%)
        </h5>
        <ReactApexChart
          options={data.options}
          series={data.series}
          type="radialBar"
          height={350}
        />
      </div>
    </div>
  );
};

export default CardEnvioDados;
